<div id="faq" class="page-layout simple full-width">

    <!-- HEADER -->
    <div class="header accent p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">
        <div class="hero-text mb-16">
            <h1>Vishing, Simulación Ataque
                <span> 
                    <mat-icon>developer_board</mat-icon>
                </span>
            </h1>
        </div>
    </div>
    <div class="flexContainer" *ngIf="muestraLead">
        <mat-card class="card" style ="width: 90%;">
            <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>Plantilla Lead</mat-card-title>
                <mat-card-subtitle>Descarga</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
            <mat-card-content>
              <p>Makensia dispone de una Plantilla con el formato para creación de Leads.</p>
              <p>Puede descargarlo directamente desde este panel.</p>
              <br>
              <button mat-raised-button (click)="descargarModelo()" class="cta-button atBottom" color="accent">
                Descarga Modelo CSV
            </button>
            </mat-card-content>
        </mat-card>

        <mat-card class="card">
            <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>Plantilla Lead</mat-card-title>
                <mat-card-subtitle>Subida</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
            <mat-card-content>
              <p>Aquí puede subir su Plantilla Lead para realizar una cola de llamadas.</p>
              <p></p>
              <br>
              <button mat-raised-button (click)="fileInput.click()" class="cta-button atBottom" color="accent">
                Carga Modelo CSV
              </button>
               
                <input hidden (change)="onFileSelected($event)" formControlName="archivo"  #fileInput type="file" id="file"
                    required>
            </mat-card-content>
        </mat-card>
       
        <mat-card class="card">
            <mat-card-header>
              <mat-card-title-group>
                <mat-card-title>Lead instantáneo</mat-card-title>
                <mat-card-subtitle>Llamada</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
            <mat-card-content>
              <p>Si desea realizar una llamada instantánea, puede usar nuestro panel de llamada instantánea.</p>
              <br>
              <button mat-raised-button (click)="llamadaLead()" class="cta-button atBottom" color="accent">
                Llamada a Lead
              </button>
            </mat-card-content>
        </mat-card>
    </div>
    <!--  /////////////////////////////////////-->
   

        <div *ngIf="!muestraLead" class="flexContainer">
            <mat-card class="leadForm" style="width: 90%;">
                <mat-card-header>
                <mat-card-title-group>
                  <mat-card-title>VISHING</mat-card-title>
                  <mat-card-subtitle>Simulate</mat-card-subtitle>
                </mat-card-title-group>
              </mat-card-header>
              <mat-card-content class="flexContainer" style="flex-direction: column;">
                <div class="flexContainer" style="flex-direction: row; padding: 2px;">
                    <mat-form-field appearance="outline" style="width: 70%;">
                        <mat-label>Mensaje</mat-label>
                        <input #mensaje id="mensaje" matInput>
                        <mat-icon matSuffix class="secondary-text">message</mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline" style="width: 20%;">
                        <mat-label>Telefono</mat-label>
                        <input #telefono id="mensaje" matInput>
                        <mat-icon matSuffix class="secondary-text">phone</mat-icon>
                    </mat-form-field>
                </div>
                <div class="flexContainer" style="flex-direction: row; padding: 2px;">
                    <button mat-raised-button (click)="fileInput.click()" class="cta-button" style="float: left;"  color="accent">
                        Cargar Audio Clonación
                      </button>
                        <input hidden (change)="onFileSelected($event)" formControlName="archivo"  #fileInput type="file" id="file"
                            required>
                </div>
                
              </mat-card-content>
              <br>
              <br>
              <br>

              <div  class="atBottom" style="margin-top: 70px;">
                <div class="flexContainer" style="flex-direction: row; padding: 2px;">
                    <button  type="submit" mat-raised-button (click)="makeCall('WhatsApp')" class="cta-button" style="margin-left: 10px;"  color="accent">
                      WhatsApp
                      <mat-icon style="color: white" matSuffix class="secondary-text">mobile_friendly</mat-icon>
                    </button>
                    <button  type="submit" mat-raised-button (click)="makeCall('Llamada')" class="cta-button" style="margin-left: 10px;"  color="accent">
                      Telefono
                      <mat-icon style="color: white"  matSuffix class="secondary-text">phone</mat-icon>
                    </button>
                    
                </div>
            </div>
            </mat-card>
        </div>
                    
        
    <!-- ///////////////////////////////////////-->
    <div *ngIf="loading" class="content-card">
        <div class="center">
            <div class="spinner-wrapper">
                <div class="spinner">
                    <div class="inner">
                        <div class="gap"></div>
                        <div class="left">
                            <div class="half-circle"></div>
                        </div>
                        <div class="right">
                            <div class="half-circle"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

